import React from 'react'
import { Link, Redirect } from 'react-router-dom';
import './login.css'
import Api from '../../services/api'
import Alert from '../../Components/alert/Alert'
import { setWithExpiry } from '../../services/Functions'
import Allestec from '../../assets/new_logo_render.png'
import '../../Components/localStyles/localStyles'
import CommonButton from '../../Components/commonButton/commonButton';


export default class Login extends React.Component {

  state = { username: '', password: '', isClicked: false, auth: false, show: false, message: "",reload:false }

  changeValueName = (value) => { this.setState({ username: value.target.value }) }
  changeValuePassword = (val) => { this.setState({ password: val.target.value }) }
  callbackfunction = () => { this.setState({ show: false }) }

  componentDidMount(){
    const token = localStorage.getItem('@oee-monitor/token')
    if(token !== null){
      this.setState({auth:true})
    }
  }
  handleKeyPress = (e) => {
    if(e.key === 'Enter'){
      this.validation();
    }
  }

  validation = (e) => {
    if (this.state.username !== '' && this.state.password !== '') {
     
      Api.post('/login/', { username: this.state.username, password: this.state.password }
      ).then((response) => {
        if (response.data.auth) {
          setWithExpiry('@oee-monitor/token', response.data.token, response.data.expiresIn)   
          localStorage.setItem('@oee-monitor/token',  response.data.token);
          localStorage.setItem('@oee-monitor/id', response.data.id);
          localStorage.setItem('@oee-monitor/user', this.state.username);
          localStorage.setItem('@oee-monitor/admin', response.data.is_admin);
          this.setState({ auth: true })
    
        } else {
          this.setState({ message: response.data.error, show: true })
        }
      }
      ).catch((err) => {
        this.setState({ message: 'Erro de conexão com o servidor.', show: true,reload:true })
      })
  
    } else {
      this.setState({ message: 'Necessário preencher todos os campos.', show: true })
    }
  }

  render() {
    const { auth,show,message,reload} = this.state;
    if (auth) {
      return (
        <Redirect to={{ pathname: "/dashboard", state: { username: this.state.username } }} />
      )
    }

    return (
      <div className="login">
        {show ? <Alert show={show} reload={reload} message={message} parentCallback={this.callbackfunction} /> : null}
         <section className="login-form">
          <form className="form-sec-login" action="">
            <div className="title-login"><img src={Allestec} ></img></div>
            <div className="input-block">
              <input
                autoFocus
                autoComplete="off"
                placeholder="Usuário"
                id="login-email"
                value={this.state.username}
                onChange={this.changeValueName}
                onKeyPress={this.handleKeyPress}
              />
            </div>
            <div className="input-block">
              <input
                autoComplete="off"
                placeholder="Senha"
                type="password"
                id="login-password"
                value={this.state.password}
                onChange={this.changeValuePassword}
                onKeyPress={this.handleKeyPress}
              />
              <div className="forget-link"><Link to="/confirmar-email">Esqueci minha senha</Link></div>
            </div>
            <CommonButton title="Entrar" icon="send" parentCallback={this.validation}/>
          </form>
          <div className='login-image-container'>
            <div className='login-image-gradient'></div>
            <div className='login-image'></div>
          </div>
       </section> 
      </div>
    )
  }
}